import { belongsTo, hasMany, Model } from 'miragejs';

export default Model.extend({
  creation: belongsTo('cc-creation'),
  shareholder: belongsTo('cc-shareholder'),
  poiDocument: belongsTo('cc-poi-document'),
  legalEntities: hasMany('cc-legal-entity'),
});
